import { runtimeConfig } from "@/services/runtimeConfig"

export const Version = () => (
  <div className="mr-lg flex h-2xl items-center text-primary opacity-60">
    <span className="text-sm-regular text-inherit">
      {runtimeConfig.releaseVersion}
    </span>
  </div>
)
